module.exports = __webpack_public_path__ + "img/galery14.372f6aff.jpg";